
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/br/[tickerSymbol]/about",
      function () {
        return require("private-next-pages/br/[tickerSymbol]/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/br/[tickerSymbol]/about"])
      });
    }
  